import HttpService from "@/utils/httpData"
import { APP_CONFIG } from '@/utils/constants'


// export const getListClass = () => {
//     var json = [
//     { "subjectId": 1, "nameSubject": "Lớp 1A6 - Môn Tiếng Việt", "nameSchool": "Trường Tiểu học Nguyễn Tất Thành", "member":"50 thành viên","classCode": "123AAAYYY" },
//     { "subjectId": 2, "nameSubject": "Lớp 1A6 - Môn Toán", "nameSchool": "Trường Tiểu học Nguyễn Tất Thành", "member":"50 thành viên","classCode": "123BBBYYY"},
//     { "subjectId": 3, "nameSubject": "Lớp 1A6 - Môn Tự nhiên và Xã hội", "nameSchool": "Trường Tiểu học Nguyễn Tất Thành", "member":"50 thành viên","classCode": "123CCCYYY"},
//     { "subjectId": 4, "nameSubject": "Lớp 1A6 - Môn Đạo đức", "nameSchool": "Trường Tiểu học Nguyễn Tất Thành", "member":"50 thành viên","classCode": "123DDDYYY"},
//     { "subjectId": 5, "nameSubject": "Lớp 1A6 - Môn Âm nhạc", "nameSchool": "Trường Tiểu học Nguyễn Tất Thành", "member":"50 thành viên","classCode": "123EEEYYY"},
//     { "subjectId": 6, "nameSubject": "Lớp 1A6 - Môn Mĩ thuật", "nameSchool": "Trường Tiểu học Nguyễn Tất Thành", "member":"50 thành viên","classCode": "123FFFYYY"},
//     ];
//     return json
// }
export const getListClass = (params = { data }) => {
    let apiEndpoint = `ClassSchool/list-joined-class-school-subject`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const ClassSchoolJoin = (params = { data }) => {
    let apiEndpoint = `ClassSchool/Join`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getListEvent = (params = { data }) => {
    let apiEndpoint = `ClassSchool/ListEvent`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const apiLeaveClass = (params = { data }) => {
    let apiEndpoint = `ClassSchool/Leave`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const ClassSchoolListMember = (params = { data }) => {
    let apiEndpoint = `ClassSchool/list-member`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getClassListDoccument = (params = { data }) => {
    let apiEndpoint = `ClassSchool/list-document`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getListLessonPlan = id => {
    let apiEndpoint = `ClassSchool/get-list-lesson-plan?classSchoolSubjectId=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getListLessonPlanChildren = id => {
    let apiEndpoint = `lesson/GetListLessonPlanChildren?lessonPlanId=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListEventByUser = (params = {}) => {
    let apiEndpoint = `ClassSchool/ListEventByUser`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListClassPosition = (params = {}) => {
    let apiEndpoint = `ClassSchool/get-list-class-position`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getSerachClass = code => {
    let apiEndpoint = `ClassSchool/get-class-school-subject?code=${code}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getCourseDetail = id => {
    let apiEndpoint = `ClassSchool/GetCourseDetail?classSchoolSubjectId=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getEventDetail = id => {
    let apiEndpoint = `ClassSchool/EventDetail?eventId=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListSubjectInWeek = () => {
    var json = [
        { "subjectWeekId": 1, "nameSubject": "Tuần 1: TÔI VÀ CÁC BẠN", "datetime": "06/01/2021 - 12/01/2021", "document": "06 bài - 18 tài liệu" },
        { "subjectWeekId": 2, "nameSubject": "Tuần 2: MÁI ẤM GIA ĐÌNH", "datetime": "06/01/2021 - 12/01/2021", "document": "06 bài - 18 tài liệu" },
        { "subjectWeekId": 3, "nameSubject": "Tuần 3: MÁI TRƯỜNG MẾN YÊU", "datetime": "06/01/2021 - 12/01/2021", "document": "06 bài - 18 tài liệu" },
        { "subjectWeekId": 4, "nameSubject": "Tuần 4: ĐIỀU CẦN BIẾT", "datetime": "06/01/2021 - 12/01/2021", "document": "06 bài - 18 tài liệu" },
        { "subjectWeekId": 5, "nameSubject": "Tuần 5: BÀI HỌC TỪ CUỘC SỐNG", "datetime": "06/01/2021 - 12/01/2021", "document": "06 bài - 18 tài liệu" },
        { "subjectWeekId": 6, "nameSubject": "Tuần 6: THIÊN NHIÊN KÌ THÚ", "datetime": "06/01/2021 - 12/01/2021", "document": "06 bài - 18 tài liệu" },
        { "subjectWeekId": 7, "nameSubject": "Tuần 7: THẾ GIỚI TRONG MẮT EM", "datetime": "06/01/2021 - 12/01/2021", "document": "06 bài - 18 tài liệu" },
        { "subjectWeekId": 8, "nameSubject": "Tuần 8: ĐẤT NƯỚC VÀ CON NGƯỜI", "datetime": "06/01/2021 - 12/01/2021", "document": "06 bài - 18 tài liệu" },
        { "subjectWeekId": 9, "nameSubject": "ÔN TẬP VÀ ĐÁNH GIÁ", "datetime": "06/01/2021 - 12/01/2021", "document": "06 bài - 18 tài liệu" },
    ];
    return json
}
export const getListMember = () => {
    var json = [
        { "id": 1, "name": "Nguyễn Văn Thịnh", "role": "Giáo viên chủ nhiệm" },
        { "id": 2, "name": "Nguyễn Văn Hoàn", "role": "Học sinh" },
        { "id": 3, "name": "Bùi Văn Dũng", "role": "Học sinh" },
        { "id": 4, "name": "Hoàng Minh Giám", "role": "Học sinh" },
        { "id": 5, "name": "Nguyễn Đình Nguyên", "role": "Học sinh" },
        { "id": 6, "name": "Nguyễn Văn A", "role": "Học sinh" },
        { "id": 7, "name": "Nguyễn Văn Hoàn", "role": "Học sinh" },
        { "id": 8, "name": "Bùi Văn Dũng", "role": "Học sinh" },
        { "id": 9, "name": "Hoàng Minh Giám", "role": "Học sinh" },
        { "id": 10, "name": "Nguyễn Đình Nguyên", "role": "Học sinh" },
        { "id": 11, "name": "Nguyễn Văn A", "role": "Học sinh" },
    ];
    return json
}

// export const getListDocument = () => {
//     var json = [
//         { "id": 1, "documentName": "Bài ôn tập kiểm tra học kì môn Tiếng Việt - Lớp 1A6", "user": "Nguyễn Văn An", "updateAt": "14:00 - 10/02/2021" },
//         { "id": 2, "documentName": "Bảng điểm Kiểm tra 45 phút - Lớp 1A6", "user": "Nguyễn Văn An", "updateAt": "14:00 - 10/02/2021" },
//         { "id": 3, "documentName": "Giấy mời họp phụ huynh", "user": "Nguyễn Văn An", "updateAt": "14:00 - 10/02/2021" },
//         { "id": 4, "documentName": "Bài ôn tập kiểm tra học kì môn Tiếng Việt - Lớp 1A6", "user": "Nguyễn Văn An", "updateAt": "14:00 - 10/02/2021" },
//         { "id": 5, "documentName": "Bảng điểm Kiểm tra 45 phút - Lớp 1A6", "user": "Nguyễn Văn An", "updateAt": "14:00 - 10/02/2021" },
//         { "id": 6, "documentName": "Giấy mời họp phụ huynh", "user": "Nguyễn Văn An", "updateAt": "14:00 - 10/02/2021" },
//         { "id": 7, "documentName": "Bài ôn tập kiểm tra học kì môn Tiếng Việt - Lớp 1A6", "user": "Nguyễn Văn An", "updateAt": "14:00 - 10/02/2021" },
//         { "id": 8, "documentName": "Bảng điểm Kiểm tra 45 phút - Lớp 1A6", "user": "Nguyễn Văn An", "updateAt": "14:00 - 10/02/2021" },
//         { "id": 8, "documentName": "Giấy mời họp phụ huynh", "user": "Nguyễn Văn An", "updateAt": "14:00 - 10/02/2021" },
//     ];
//     return json
// }
export default {
    getListClass,
    getListSubjectInWeek,
    getListMember,
    // getListDocument
};